import React, { useState } from 'react';

const TabSlider = ({ subcategories, subCatOnClick, isMenu = false, style = {}, defaultTab = 0, TextStyle = {}, setOnlyIndex = false }) => {
	const [selectedTab, setSelectedTab] = useState(defaultTab);

	const handleTabClick = (index, subcategory) => {
		setSelectedTab(index);
		if (subCatOnClick) {
			subCatOnClick(setOnlyIndex ? index : subcategory);
		}
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center', marginLeft: isMenu ? "-80px" : 0 }}>
			{subcategories.length > 0 && (
				<div className={`tab-container ${isMenu ? "tab-hide" : ""}`} style={style}>
					{subcategories.map((subcategory, index) => (
						<React.Fragment key={index}>
							<div
								className={`tab-label`}
								onClick={() => handleTabClick(index, subcategory)}
								style={{
									fontWeight: "500",
									cursor: 'pointer',
									padding: isMenu ? "4px 40px" : "4px 30px",
									paddingLeft: isMenu ? "30px" : "30px",
									borderRadius: '15px',
									background: selectedTab === index ? 'rgb(59 130 246)' : '#FFF',
									color: selectedTab === index ? 'white' : 'black',
									fontSize: "12px",
									transition: 'background-color 0.3s ease, color 0.3s ease', // Add transition here
									...TextStyle
								}}
							>
								{subcategory}
							</div>
						</React.Fragment>
					))}
				</div>
			)}
		</div>
	);
};

export default TabSlider;
